module.exports = __webpack_public_path__ + "img/abs.8e5e8f63.jpg";